<template>
  <Button
    v-bind="attrsWithoutClass"
    :label="label"
    :size="size"
    :icon="icon"
    :iconPos="iconPos"
    :as="as"
    :to="to"
    :class="mergedClass"
  >
    <template v-if="$slots.icon" #icon>
      <slot name="icon" />
    </template>
  </Button>
</template>

<script setup>
import { computed, useAttrs } from 'vue'

defineProps({
  label: String,
  size: { type: String, default: 'small' },
  icon: String,
  iconPos: { type: String, default: 'left' },
  as: String,
  to: [String, Object],
})

defineOptions({ inheritAttrs: false })

const attrs = useAttrs()

const baseClass = '!bg-[#2db9d6] !border-[#2db9d6] hover:!bg-[#259cb5] hover:!text-gray-50 whitespace-nowrap !text-[#041E42]'

const mergedClass = computed(() => [baseClass, attrs.class])

const attrsWithoutClass = computed(() => {
  const { class: _, ...rest } = attrs
  return rest
})
</script>
